import { ScrollArea } from 'components/elements';
import { classNameBlurred, styled } from 'styles';

export const StyledPage = styled(ScrollArea)`
  height: 100%;
  transition: filter ${({ theme }) => theme.transition.fast} ease-in-out;

  .${classNameBlurred} & {
    filter: blur(0.25rem);
  }
`;

StyledPage.displayName = 'Page.Styled';
